import { Check } from "lucide-react";

import { AGENT_ICONS } from "@/lib/agent-icons";
import { cn } from "@/lib/utils";

interface Props {
  value: string | null;
  onChange: (name: string | null) => void;
}

export function AgentIconPicker({ value, onChange }: Props) {
  return (
    <div className="grid grid-cols-8 gap-2 rounded-md border border-input bg-background p-2">
      {AGENT_ICONS.map(({ name, Icon, label }) => {
        const selected = value === name;
        return (
          <button
            key={name}
            type="button"
            title={label}
            aria-label={label}
            aria-pressed={selected}
            onClick={() => onChange(selected ? null : name)}
            className={cn(
              "flex h-9 w-9 items-center justify-center rounded-md border border-transparent transition-colors",
              selected
                ? "border-ring bg-accent text-accent-foreground"
                : "hover:bg-accent/50",
            )}
          >
            {selected ? (
              <span className="relative">
                <Icon className="h-5 w-5" />
                <Check className="absolute -right-3 -top-3 h-3 w-3" />
              </span>
            ) : (
              <Icon className="h-5 w-5" />
            )}
          </button>
        );
      })}
    </div>
  );
}
